import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { MoreButtonCDS } from '@sharedCR/coreDesignSystem/Buttons';
import { DeleteIcon, EditPenIcon } from '@sharedCR/coreDesignSystem/icons';
import MenuPopoverCDS from '@sharedCR/coreDesignSystem/MenuPopoverCDS';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { ConfirmationModalType } from 'constants/confirmationDialog';
import { IconSize } from 'constants/coreDesignSystem';
import usePopover from 'hooks/usePopover';

import { openConfirmationDialogAction } from 'store/global/actions';

const defaultRowData = {};

const ActionButton = ({
  isDisabled = false,
  isEditDisabled = false,
  rowData = defaultRowData,
  setEditableTableData = _.noop,
  deleteTableData = _.noop,
}) => {
  const dispatch = useDispatch();

  const { anchorEl, onSetAnchorElement, onClearAnchorElement } = usePopover();

  const onClickEdit = useCallback(() => {
    onClearAnchorElement();

    setEditableTableData(rowData);
  }, [onClearAnchorElement, rowData, setEditableTableData]);

  const onClickRemove = useCallback(() => {
    onClearAnchorElement();

    dispatch(
      openConfirmationDialogAction({
        type: ConfirmationModalType.WARNING,
        message: 'Remove denial reason',
        description: 'Are you sure you want to remove this denial reason?',
        onAccept: () => {
          deleteTableData({ id: rowData.id });
        },
      }),
    );
  }, [deleteTableData, dispatch, onClearAnchorElement, rowData.id]);

  const items = useMemo(
    () => [
      {
        text: 'Edit',
        onClick: onClickEdit,
        icon: <EditPenIcon size={IconSize[20]} />,
        isDisabled: isEditDisabled,
      },
      {
        text: 'Delete',
        onClick: onClickRemove,
        icon: <DeleteIcon size={IconSize[20]} />,
      },
    ],
    [onClickEdit, onClickRemove, isEditDisabled],
  );

  return (
    <>
      <MoreButtonCDS disabled={isDisabled} isSelected={!!anchorEl} onClick={onSetAnchorElement} />

      <MenuPopoverCDS anchorEl={anchorEl} items={items} onClose={onClearAnchorElement} />
    </>
  );
};

ActionButton.propTypes = {
  isDisabled: PropTypes.bool,
  isEditDisabled: PropTypes.bool,
  rowData: PropTypes.object,
  setEditableTableData: PropTypes.func,
  deleteTableData: PropTypes.func,
};

export default ActionButton;
